import { Mesh } from "./Mesh";

export class MeshManager {

    private meshes: Map<string, Mesh>;
    constructor() {
        this.meshes = new Map();
    }

    public addMesh(reference: string, mesh: Mesh) {
        this.meshes.set(reference, mesh);
    }

    public getMesh(reference: string): Mesh {
        return this.meshes.get(reference);
    }
}